module.exports = __webpack_public_path__ + "img/seedling.edca5151.svg";